module.exports = __webpack_public_path__ + "media/images/admin/icons/web-08d8e425eb6ea811546e8884c7fef630.png";